import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { lastValueFrom } from 'rxjs';
import { EndPointApi } from '@helpers/endpointapi';
import { Mimic } from 'ops/common/models/mimic';

@Injectable({
    providedIn: 'root',
})
export class MimicService {
    private domain: string;

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    getAll(): Promise<Mimic[]> {
        return lastValueFrom(this.http.get<Mimic[]>(`${this.domain}/api/mimic`));
    }

    getById(mimicId: string): Promise<Mimic> {
        return lastValueFrom(this.http.get<Mimic>(`${this.domain}/api/mimic/${mimicId}`));
    }
}
